import React, { useEffect, useState } from 'react'
import { Layout } from 'antd'
import styled from 'styled-components'
import { ComponentValidator } from '../auth/Validator'
import { SidebarMenu } from './SidebarMenu'
import { AppHeader } from './Header'
import { isLoggedIn, logout } from 'src/libs/browser'
import { useRouter } from 'next/router'
import { URL_TEMPLATE } from 'src/libs/constant'
import Link from 'next/link'
import Icon from '@ant-design/icons'

const { Content, Footer, Sider } = Layout
const URL_NOT_LAYOUT = [
  URL_TEMPLATE.SYSTEM_LOGIN,
  URL_TEMPLATE.REDIRECT,
  URL_TEMPLATE.CLASS_DEMO_LINK_VIDEO,
  URL_TEMPLATE.LEAN_SALE_DEMO
  // URL_TEMPLATE.TUTOR_QUALITY_REPORT_RESPONSIVE
]

export function AppLayout ({ children, sidebarIsCollapsed, setSidebarCollapsed }) {
  // const [sidebarIsCollapsed, setSidebarCollapsed] = useState(false)
  const [collapsedWidth] = useState(256)
  const [date, setDate] = useState(new Date())
  const router = useRouter()

  useEffect(() => {
    if (!isLoggedIn() && ![URL_TEMPLATE.SYSTEM_LOGIN].includes(router.pathname)) {
      logout()
      const url = router.asPath
      const query = url && url !== '/' && `?from=${encodeURIComponent(url)}`
      router.replace(`${URL_TEMPLATE.SYSTEM_LOGIN}${query || ''}`)
    }
  }, [])

  if (URL_NOT_LAYOUT.includes(router.pathname)
    || router.pathname.startsWith(URL_TEMPLATE.TUTOR_QUALITY_REPORT_RESPONSIVE)
    || router.pathname.startsWith(URL_TEMPLATE.QUALITY_CONTROL_DISCIPLINE)
    || router.pathname.startsWith(URL_TEMPLATE.QUALITY_CONTROL_LESSON)
    || router.pathname.startsWith(URL_TEMPLATE.QUALITY_ASSURANCE_SPECIALIZE)
    || router.pathname.startsWith(URL_TEMPLATE.QUALITY_ASSURANCE_TRAINING_POINT))
  {
    return children
  }

  const headerLogo = sidebarIsCollapsed && collapsedWidth === 0 && (
    <CustomLogo className='logo'>
      <img src='/logo_new.png' alt='logo' style={{ width: 200, height: 50 }} />
    </CustomLogo>
  )
  return (
    <ComponentValidator visible={isLoggedIn()} loading>
      <Layout>
        <Sider
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            height: 'calc(100vh)',
            position: 'fixed',
            left: 0,
            zIndex: 100,
          }}
          collapsedWidth={90}
          collapsed={sidebarIsCollapsed}
          breakpoint='md'
          width={256}
        >
          <div
            style={{
              minHeight: 60,
              padding: sidebarIsCollapsed ? '15px 0 17px 0' : '17px 17px',
              transition: 'all 0.2s ease-out'
            }}
          >
            <Link href={URL_TEMPLATE.SYSTEM_DASHBOARD}>
              <img
                src={'/logo_new.png'}
                alt='logo'
                style={{
                  width: 222,
                  marginLeft: sidebarIsCollapsed ? '25px' : 0,
                  height: 60,
                  transition: 'all 0.2s ease-out',
                  cursor: 'pointer'
                }}
              />
            </Link>
          </div>
          <SidebarMenu sidebarIsCollapsed={sidebarIsCollapsed} />
        </Sider>
        <Icon
          className='icon-colap-side-bar'
          style={{
            top: 68,
            left: sidebarIsCollapsed ? 75 : 240,
            zIndex: 100,
            border: 'none',
            display: 'flex',
            position: 'fixed',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(249, 250, 251, 1)',
            borderRadius: '50%',
            fontSize: '13px',
            cursor: 'pointer',
            transition: 'all 0.2s linear',
            color: 'rgba(55, 65, 81, 1)',
            border: '2px solid rgba(229, 231, 235, 1)',
            padding: '3px',
            width: '28px',
            height: '28px',
          }}
          onClick={() => {
            setSidebarCollapsed(prev => !prev)
          }}
          component={() => (sidebarIsCollapsed ? <img src='/image/ui-kit/sidebar/larger-icon.png'
                                                      style={{ width: '5px', height: '10px' }} /> : <img
            src='/image/ui-kit/sidebar/smaller-icon.png' style={{ width: '5px', height: '10px' }} />)}
        />
        <Layout
          className='site-layout main-layout'
          style={{
            marginLeft: sidebarIsCollapsed ? 90 : 256,
            transition: 'margin-left 0.2s',
            background: '#fafafa'
          }}
        >
          <AppHeader logo={headerLogo} />
          <Content
            style={{
              margin: '24px 20px 0',
              overflow: 'initial',
              minHeight: 'calc(100vh - 104px)'
            }}
          >
            {children}
          </Content>
          {/* <Footer>
            <div className='float-right d-none d-sm-inline'>
              &quot;Customer first&quot;
            </div>
            <strong>
              Copyright &copy; 2021{' '}
              <a href='https://edupia.vn' className='mx-3'>
                edupiatutor.vn
              </a>
            </strong>
            All rights reserved.
          </Footer> */}
        </Layout>
      </Layout>
    </ComponentValidator>
  )
}

const CustomLogo = styled.div`
    &.logo {
        float: left;
        width: 120px;
        height: 31px;
        margin: 16px 24px 16px 0;
    }
`
